import Login from "./steps/login/Login";
import PreveiwData from "./steps/preview-data/PreviewData";
import StoresPricelist from "./steps/stores-pricelist/StoresPricelist";
import Stores from "./steps/stores/Stores";
import Success from "./steps/success/Success";

export const FORM_STEP = {
  1: { step: 1, Component: Login },
  2: { step: 2, Component: Stores },
  3: { step: 3, Component: StoresPricelist },
  4: { step: 4, Component: PreveiwData },
  5: { step: 5, Component: Success },
};

export const FORM_FIELDS = {
  LOGIN_DATA: {
    name: "loginData",
    USERNAME: {
      name: "username",
      title: "Korisničko ime",
    },
    PASSWORD: {
      name: "password",
      title: "Lozinka",
    },
    OIB: {
      name: "oib",
      title: "OIB klijenta",
    },
    BEARER_TOKEN: {
      name: "bearer",
      title: "",
    },
  },
  STORE_DATA: {
    name: "storeData",
    title: "Prodajna mjesta",
    // FIELDS
    ID: { name: "id", title: "" },
    ADDRESS_SAME_AS_CLIENT: { name: "addressSameAsClient", title: "" },
    DESCRIPTION: { name: "description", title: "Opis/Naziv" },
    TAG: { name: "tag", title: "Oznaka prodajnog mjesta" },
    TYPE: { name: "type", title: "Tip prodajnog mjesta" },
    FOOTER_NOTE: { name: "footerNote", title: "Tekst podnožja računa" },
    STREET: { name: "street", title: "Adresa prodajnog mjesta" },
    STREET_NUMBER: { name: "streetNumber", title: "Kućni broj" },
    STREET_NUMBER_EXTENSTION: {
      name: "streetNumberExtension",
      title: "Dodatak",
    },
    POSTAL_NUMBER: { name: "postalNumber", title: "Poštanski broj" },
    CITY: { name: "city", title: "Grad" },
    // POS DATA
    POS_DATA: {
      name: "posData",
      // FIELDS
      TAG: { name: "tag", title: "Oznaka" },
      INVENTORY_NUMBER: { name: "inventoryNumber", title: "ICT broj" },
      DOCUMENT_NUMBER: { name: "documentNumber", title: "Br rač" },
      DEPOSIT: { name: "deposit", title: "Deposit" },
      MSISDN: { name: "msisdn", title: "MSISDN" },
      POS_SERIAL_NUMBER: {
        name: "posSerialNumber",
        title: "Serijski br",
      },
    },
    PRICE_LIST_DATA: {
      name: "priceListData",
      ID: { name: "id", title: "Id" },
      NAME: { name: "name", title: "Naziv" },
      CODE: { name: "code", title: "Kod" },
      BAR_CODE: { name: "barCode", title: "Bar kod" },
      DESCRIPTION: { name: "description", title: "Opis" },
      IS_SERVICE: { name: "isService", title: "Usluga" },
      UNIT_OF_MEASURE: { name: "unitOfMeasure", title: "Jedinica mjere" },
      TAX_RATE: { name: "taxRate", title: "Porezna stopa" },
      ITEM_GROUP: {
        name: "itemGroup",
        title: "Grupa artikala",
      },
      PRICE: { name: "price", title: "Cijena" },
      PN: { name: "pn", title: "Povratna naknada" },
      PP: { name: "pp", title: "Pp" },
      FILE: { name: "file", title: "Datoteka" },
    },
  },
};

export const FORM_INITIAL_DATA = {};
